/** @format */

import {ReactNode} from 'react';

import {Modal} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import {
  BgPaper,
  CloseButton,
  Content,
  Header,
  HeaderContent,
  HeaderIcon,
  HeaderText,
  HeaderTextBox,
  ModalType,
  SubHeaderText,
} from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  subHeaderText?: string;
  headerIcon?: ReactNode;
  children: ReactNode;
  type?: ModalType;
}

const ModalSimple = ({
  isOpen,
  onClose,
  headerText,
  subHeaderText,
  headerIcon,
  children,
  type = 'primary',
}: Props) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <BgPaper>
        <Header customType={type}>
          <HeaderContent>
            {headerIcon && <HeaderIcon customType={type}>{headerIcon}</HeaderIcon>}
            <HeaderTextBox>
              <HeaderText>{headerText}</HeaderText>
              {subHeaderText && <SubHeaderText>{subHeaderText}</SubHeaderText>}
            </HeaderTextBox>
          </HeaderContent>

          <CloseButton customType={type} disableRipple onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <Content>{children}</Content>
      </BgPaper>
    </Modal>
  );
};

export {ModalSimple};
